<template>
    <f7-page name="ownermanual">
        <bc-navbar></bc-navbar>
        <br/>
        <div class="layout_fullwidth_padding">
            <div v-show="isRequestActive" class="loader">
                <looping-rhombuses-spinner :animation-duration="2500" :rhombus-size="15" color="#f9f300" />
            </div>
            <h3>Owner's Manual</h3>
            <h5>Vehicle Make</h5>
            <select @change="setMakes()" v-model="ownerModel.make">
                <option v-for="make in makes" :key="make" :value="make">{{make}}</option>
            </select>
            <h5>Vehicle Model</h5>
            <select @change="setModels()" v-model="ownerModel.model" :disabled="models.length==0?true:false">
                <option v-for="curModel in models" :key="curModel" :value="curModel">{{curModel}}</option>
            </select>
            <h5>Vehicle Year</h5>
            <select @change="setYears()" v-model="ownerModel.year" :disabled="years.length==0?true:false">
                <option v-for="year in years" :key="year" :value="year">{{year}}</option>
            </select>
            <a class="button_full btyellow external" @click="openBrochure(owner)" v-for="owner in owners" :key="owner.id"
                target="_blank" :href="owner.fileUrl" :style="borderStyle" >
                Download {{owner.year}} {{owner.make}} {{owner.model}} {{owner.submodel}} Manual</a>

            <h3  style="padding-top: 40px;">Owner's Manual Saved history</h3>
            <ul class="responsive_table" >
                <li class="table_row" :style="borderStyle"  >
                    <div class="table_section table_section_brochure">Manual</div>
                    <div class="table_section" >Date</div>
                </li>
               
                <li class="table_row" v-for="ownerH in ownerHistory" :key="ownerH.openDate">
                    <div class="table_section table_section_brochure"><a :href="ownerH.url"  @click="openBrochure(ownerH)" target="_blank" class="external">{{ownerH.year}} {{ownerH.make}} {{ownerH.model}} {{ownerH.submodel}}</a></div>
                    <div class="table_section">{{(ownerH.openDate != null? new Date(ownerH.openDate).toLocaleDateString():"New brochure")}}</div>
                </li>
            </ul>
        </div>
    </f7-page>
</template>

<script>
    /* eslint-disable */
    import { mapState, mapGetters, mapActions } from 'vuex'
    import { LoopingRhombusesSpinner } from 'epic-spinners'

    export default {
        //Lifecycle
        components: {
            LoopingRhombusesSpinner
        },
        mounted: function () {
            this.isRequestActive = true;
            this.$store.dispatch('ownerManual/loadOwnerHistory').then(
                function () {
                    this.$store.dispatch('ownerManual/loadOwnerMakes')
                        .then(() => { this.isRequestActive = false; });
                        console.log(this.ownerHistory);
                }.bind(this)).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });

        },
        computed:{ 
            ...mapState({
            makes: state => state.ownerManual.makes,
            models: state => state.ownerManual.models,
            years: state => state.ownerManual.years,
            owners: state => state.ownerManual.owners,
            ownerHistory: state => state.ownerManual.ownersHistory,
            customization: state => state.common.customization
        }),
        borderStyle: function(){     
            var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor :  'none';
            var backgroundStyle = this.customization.mainColor;
            var colorStyle = this.customization.fontColor
            return {
                border: borderStyle, 
                background: backgroundStyle,
                color:colorStyle
            };
         }    
        },
        methods: {
            setMakes() {
                this.isRequestActive = true; 
                this.$store.dispatch('ownerManual/loadOwnerModels', this.ownerModel)
                    .then(() => { this.isRequestActive = false; }).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
            setModels() {
                this.isRequestActive = true;
                this.$store.dispatch('ownerManual/loadOwnerYears', this.ownerModel)
                    .then(() => { this.isRequestActive = false; }).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
            setYears() {
                this.isRequestActive = true;
                this.$store.dispatch('ownerManual/loadOwner', this.ownerModel)
                    .then(() => { this.isRequestActive = false; }).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
            openBrochure(brochure) {
                console.log(brochure);
                console.log(this.ownerModel);
                this.isRequestActive = true;
                this.$store.dispatch('ownerManual/addOwner', brochure).then(function () {
                    this.$store.dispatch('ownerManual/loadOwnerHistory').then(()=>{
                        this.isRequestActive = false; 
                    });
                }.bind(this)).catch(x=> {
      this.$f7.mainView.router.load({url: 'error'});
    });
            },
        },
        data() {
            return {
                ownerModel: {
                    make: "Select company/brand",
                    model: "Select model",
                    year: "Select year"
                },
                isRequestActive: false
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .button_full {
        margin-top: 20px
    }

    select {
        width: 100%;
        height: 35px;
        font-size: 18px;
        padding-left: 5px;
    }

    h5 {
        font-weight: bold;
        padding: 10px 0 10px 0;
    }

    .loader {
        position: absolute;
    }
    .table_section_brochure{
        width:55%
    }
</style>


// WEBPACK FOOTER //
// ownermanual.vue?4ffe1d8b